module.exports = __webpack_public_path__ + "static/aissa-1c2c2ee8ba55760a693f1db99b1f5797.png";